
import global from '@/assets/js/global'
const data = {}
if (global.tenantCode === '451000000000000001') { //百色
  data.rmyjzjUrl = ''
  data.xxgchyjsUrl = 'https://www.zyshgzb.gov.cn/459386/459573/index.html'
  data.footerData = {
    partyOrgan: '',//党政机关跳转地址
    organizer: '中国共产党百色市委员会社会工作部 ',//主办单位
    address: '广西壮族自治区百色市右江区前程路生态环境局大楼6楼',//地址
    zipCode: '533000',//邮编
    technicalSupport: '百色电信',  //技术支持
    icpText: '桂ICP备2025071435号-1',//ICP备案号
    icpHttp: 'https://beian.miit.gov.cn/',//ICP备案号跳转地址
    publicSecurityText: '桂公网安备45100202000447号',//公安备案号
    publicSecurityHttp: 'https://beian.mps.gov.cn/#/query/webSearch?code=45100202000447',//公安备案号跳转地址
    phone:'0776-2872056（仅受理网站建设维护相关问题）'
  }
  data.ywValue = '1'//要闻默认值
  data.rdywList = [
  {
    label: '时政要闻',
    value: '1',
    navCode: '078'
  },]
  data.rmyjzjList = [
    { label: '百色市', url: '/sugSolicitationHomePage', img: 'hjs.png', },
    { label: '其他地区', url: 'https://www.zyshgzb.gov.cn/459441/index.html', img: 'hjs.png', },
    // { label: '‌南宁市‌', url: '', img: 'nxs.png', },
    // { label: '柳州市', url: '', img: 'lzs.png', },
    // { label: '桂林市‌', url: '', img: 'gls.png', },
    // { label: '梧州市‌', url: '', img: 'wzs.png' },
    // { label: '北海市‌', url: '', img: 'bhs.png', },
    // { label: '防城港市‌', url: '', img: 'fcgs.png', },
    // { label: '钦州市', url: '', img: 'qzs.png', },
    // { label: '贵港市‌', url: '', img: 'ggs.png', },
    // { label: '‌玉林市‌', url: '', img: 'yls.png', },
    // { label: '百色市', url: '', img: 'bss.png', },
    // { label: '贺州市‌', url: '', img: 'hzs.png', },
    // { label: '河池市‌', url: '', img: 'hds.png', },
    // { label: '来宾市‌', url: '', img: 'lbs.png', },
    // { label: '崇左市‌', url: '', img: 'czs.png', },
  ]
  data.xxxtList = [
    // { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA1.png' },
    // { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA2.png' },
    // { label: '', url: 'https://www.zyshgzb.gov.cn/459484/index.html', img: '/xxxtA3.png' },
    { label: '', url: 'https://gxguizhiyuan.com/volunteer-pc/#/home/index', img: '/xxxtA4.jpeg' },
  ]
  data.wxjzList = [
    {
      label: '百色市',
      url: '',
      img: 'bss.png',
      wximg: 'bss_wx.png',
      value: '01'
    },
    // {
    //   label: '‌南宁市‌',
    //   url: '',
    //   img: 'nxs.png',
    //   wximg: 'nxs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '柳州市',
    //   url: '',
    //   img: 'lzs.png',
    //   wximg: 'lzs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '桂林市‌',
    //   url: '',
    //   img: 'gls.png',
    //   wximg: 'gls_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '梧州市‌',
    //   url: '',
    //   img: 'wzs.png',
    //   wximg: 'wzs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '北海市‌',
    //   url: '',
    //   img: 'bhs.png',
    //   wximg: 'bhs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '防城港市‌',
    //   url: '',
    //   img: 'fcgs.png',
    //   wximg: 'fcgs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '钦州市',
    //   url: '',
    //   img: 'qzs.png',
    //   wximg: 'qzs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '贵港市‌',
    //   url: '',
    //   img: 'ggs.png',
    //   wximg: 'ggs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '‌玉林市‌',
    //   url: '',
    //   img: 'yls.png',
    //   wximg: 'yls_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '百色市',
    //   url: '',
    //   img: 'bss.png',
    //   wximg: 'bss_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '贺州市‌',
    //   url: '',
    //   img: 'hzs.png',
    //   wximg: 'hzs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '河池市‌',
    //   url: '',
    //   img: 'hds.png',
    //   wximg: 'hds_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '来宾市‌',
    //   url: '',
    //   img: 'lbs.png',
    //   wximg: 'lbs_wx.png',
    //   value: '01'
    // },
    // {
    //   label: '崇左市‌',
    //   url: '',
    //   img: 'czs.png',
    //   wximg: 'czs_wx.png',
    //   value: '01'
    // },

  ]
}
export default {
  data
}
